import { useFrame } from '~/shared/utils';

/**
 * The CMS kill switch for the whole comparison feature - shares `enableAIChatbot` rather than
 * a dedicated flag, since picking "Sammenlign" hands the selection to that same AI chat.
 * Every comparison entry point checks this, so the feature can be pulled without a deploy.
 */
export const useIsProductComparisonEnabled = () => {
    const { data: frame } = useFrame();

    return frame.settings?.enableAIChatbot === true;
};
